"use client"

import { Button } from "@/components/ui/button"
import { ANALYTICS_EVENTS, track } from "@/lib/analytics"

interface HeroCTAButtonProps {
  ctaText: string
}

export function HeroCTAButton({ ctaText }: HeroCTAButtonProps) {
  const handleCTAClick = () => {
    track(ANALYTICS_EVENTS.ctaClick, { location: "hero" })
    const contactElement = document.querySelector("#contact")
    if (contactElement) contactElement.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <Button
      onClick={handleCTAClick}
      className="rounded-none border-2 border-brand-90 bg-brand-90 text-brand-1 hover:bg-[hsl(var(--giof-pink))] hover:text-brand-1 cursor-pointer transition-all hover:scale-100"
      size="lg"
    >
      {ctaText}
    </Button>
  )
}
